
import { Vue, Component, Prop } from "vue-property-decorator"
import { Postscript } from "types/postscript"

@Component
export default class Popup extends Vue {
  @Prop()
  private postscript!: Postscript["data"]

  private checkBoxChecked = false

  get canConvert(): boolean {
    return this.forbidden || this.caution
  }

  get forbidden(): boolean {
    return this.postscript.alertLevel === "forbidden"
  }

  get caution(): boolean {
    return this.postscript.alertLevel === "caution"
  }

  get confirm(): boolean {
    return this.postscript.alertLevel === "confirm"
  }

  private created() {
    this.checkBoxChecked = this.forbidden
  }

  private changeCheckBox(e: InputEvent) {
    const target = e.target
    if (target == null || !(target instanceof HTMLInputElement)) {
      return
    }
    const element = target.closest(".highlight")
    if (element == null) {
      return
    }

    if (target.checked) {
      if (this.forbidden) {
        element.classList.add("forbidden")
        element.classList.remove("caution")
      } else if (this.caution) {
        element.classList.remove("caution")
        element.classList.add("forbidden")
      }
    } else {
      if (this.forbidden) {
        element.classList.remove("forbidden")
        element.classList.add("caution")
      } else if (this.caution) {
        element.classList.add("caution")
        element.classList.remove("forbidden")
      }
    }
  }
}
